import React, { useState } from "react";
import "./TestCaseGenerator.css";

function TestCaseGenerator() {
  const [feature, setFeature] = useState("");
  const [loading, setLoading] = useState(false);
  const [testcases, setTestcases] = useState("");

  const generateTestCases = async () => {
    if (!feature.trim()) {
      alert("Please enter a feature description.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/testcases`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ feature }),
        }
      );

      if (!response.ok) {
        console.error("BACKEND ERROR:", response.status, response.statusText);
        alert("Backend error. Please try again.");
        setLoading(false);
        return;
      }

      const data = await response.json();
      setTestcases(data.testcases || "No test cases generated.");
    } catch (error) {
      console.error("FETCH ERROR:", error);
      alert("Failed to generate test cases.");
    }

    setLoading(false);
  };

  return (
    <div className="tc-container">
      <h1 className="tc-title">🧪 AI Test Case Generator</h1>

      <textarea
        className="tc-input"
        placeholder="Enter a feature description, e.g., 'Login page authentication'"
        value={feature}
        onChange={(e) => setFeature(e.target.value)}
      />

      <button className="tc-btn" onClick={generateTestCases} disabled={loading}>
        {loading ? "Generating..." : "Generate Test Cases"}
      </button>

      {testcases && (
        <div className="tc-output">
          <h3>Generated Test Cases:</h3>
          <pre>{testcases}</pre>
        </div>
      )}
    </div>
  );
}

export default TestCaseGenerator;
